import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import { RootState } from "../../../../../redux";
import { TypesAction } from "../../../../../redux/typesAction";
import { convertToNumber } from "../../../../../utils/storage";
import type { SizeDetailState } from "../useSizeDetail";

export function useItemDetailCartActions(
  infoDetail: SizeDetailState,
  count: string,
  priceItem: unknown,
) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { auth } = useSelector((state: RootState) => state.auth);
  const { carts } = useSelector((state: RootState) => state.cart);

  const canAddToCart = React.useCallback(
    (newItem: any) => {
      if (carts.length === 0) return true;
      return carts[0].isCategory === newItem.isCategory;
    },
    [carts],
  );

  const onAddToCart = React.useCallback(() => {
    const product = {
      ...infoDetail,
      sizeName: infoDetail?.name,
      size_id: infoDetail?.id,
      quantity: convertToNumber(count),
      price: Number(priceItem) || 0,
      extractID: infoDetail?.product_id + "" + infoDetail?.id,
      isCategory: infoDetail?.category_id === 1 ? "pcs" : "plt",
      thumbnail: infoDetail?.images,
    };

    if (!auth?.access_token) {
      navigate("/login");
      return;
    }
    if (!canAddToCart(product)) {
      toast.error("You can only add one product type to cart");
      return;
    }
    dispatch({ type: TypesAction.ADD_TO_CART, payload: product });
    toast.success("Added product to cart successfully");
  }, [auth?.access_token, canAddToCart, count, dispatch, infoDetail, navigate, priceItem]);

  const onViewCart = React.useCallback(() => {
    if (auth?.access_token) navigate("/cart");
    else navigate("/login");
  }, [auth?.access_token, navigate]);

  const onMobileAddToCart = React.useCallback(() => {
    const product = {
      ...infoDetail,
      sizeName: infoDetail?.name,
      size_id: infoDetail?.id,
      quantity: convertToNumber(count),
      price: Number((infoDetail as any)?.user_group_prices?.[0]) || 0,
      extractID: infoDetail?.product_id + "" + infoDetail?.id,
      isCategory: infoDetail?.category_id === 1 ? "pcs" : "plt",
    };
    if (!auth?.access_token) {
      navigate("/login");
      return;
    }
    if (!canAddToCart(product)) {
      toast.error("You can only add one product type to cart");
      return;
    }
    dispatch({ type: TypesAction.ADD_TO_CART, payload: product });
    toast.success("Added product to cart successfully");
  }, [auth?.access_token, canAddToCart, count, dispatch, infoDetail, navigate]);

  return { onAddToCart, onViewCart, onMobileAddToCart };
}
